import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationAR from './lang/ar.json';
import translationEN from './lang/en.json';

const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'ar',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
